var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.787354 8C1.41402 4.58667 4.40535 2 8.00002 2C11.5947 2 14.5854 4.58667 15.2127 8C14.586 11.4133 11.5947 14 8.00002 14C4.40535 14 1.41469 11.4133 0.787354 8ZM8.00002 11.3333C8.88408 11.3333 9.73192 10.9821 10.357 10.357C10.9822 9.7319 11.3334 8.88406 11.3334 8C11.3334 7.11595 10.9822 6.2681 10.357 5.64298C9.73192 5.01786 8.88408 4.66667 8.00002 4.66667C7.11596 4.66667 6.26812 5.01786 5.643 5.64298C5.01788 6.2681 4.66669 7.11595 4.66669 8C4.66669 8.88406 5.01788 9.7319 5.643 10.357C6.26812 10.9821 7.11596 11.3333 8.00002 11.3333ZM8.00002 10C7.46959 10 6.96088 9.78929 6.58581 9.41421C6.21073 9.03914 6.00002 8.53043 6.00002 8C6.00002 7.46957 6.21073 6.96086 6.58581 6.58579C6.96088 6.21071 7.46959 6 8.00002 6C8.53045 6 9.03916 6.21071 9.41423 6.58579C9.78931 6.96086 10 7.46957 10 8C10 8.53043 9.78931 9.03914 9.41423 9.41421C9.03916 9.78929 8.53045 10 8.00002 10Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDark);
export default __webpack_public_path__ + "static/media/eye-dark.9589bb58fae39126a86887725803a660.svg";
export { ForwardRef as ReactComponent };